import { render, staticRenderFns } from "./ScrollFixedBottomBar.vue?vue&type=template&id=65ecf966"
import script from "./ScrollFixedBottomBar.vue?vue&type=script&lang=js"
export * from "./ScrollFixedBottomBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollFixedBottomBar.vue?vue&type=style&index=0&id=65ecf966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports